import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import noop from '../utils/noop';
import Icon from '../icon';
import Text from '../text';
import Button from '../button';

function UpgradePopover({ onUpgradeClick = noop, captions, animateId = null, id }) {
  const animated = animateId === id;

  return (
    <div className={classnames('ws-upgrade-popover', animated && 'ws-upgrade-popover--animated')}>
      <div className="ws-upgrade-popover__content">
        <Icon size="25" glyph="arrow-up-circle" className="ws-upgrade-popover__icon" />
        <div className="ws-upgrade-popover__container">
          <Text className="ws-upgrade-popover__text" type="regular">
            {captions.description}
          </Text>
          <Button type="cta" className="ws-upgrade-popover__button" onClick={onUpgradeClick}>
            {captions.upgrade}
          </Button>
        </div>
      </div>
    </div>
  );
}

UpgradePopover.propTypes = {
  id: PropTypes.string.isRequired,
  animateId: PropTypes.string,
  onUpgradeClick: PropTypes.func,
  captions: PropTypes.shape({
    description: PropTypes.string,
    upgrade: PropTypes.string,
  }).isRequired,
};

export default UpgradePopover;
